var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) { o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } } return t; }
import * as React from "react";
function SvgNo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.2633 20H21.7367C20.7775 20 20 20.7775 20 21.7367V42.2633C20 43.2225 20.7775 44 21.7367 44H42.2633C43.2225 44 44 43.2225 44 42.2633V21.7367C44 20.7775 43.2225 20 42.2633 20Z",
    fill: "#FFBEA9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.7351 25.7787L25.1583 28.3555L35.5057 38.7029L38.0825 36.1261L27.7351 25.7787Z",
    fill: "#443962"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M35.5057 25.819L25.1583 36.1664L27.7351 38.7432L38.0825 28.3958L35.5057 25.819Z",
    fill: "#443962"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNo);
export default __webpack_public_path__ + "static/media/no.1159008c99fff7bb4bd795e66407bd75.svg";
export { ForwardRef as ReactComponent };